import { useEffect, useState } from 'react';
import axiosService from 'services/axiosService';
import { DOMAIN } from 'constants';

function TranhChapKhieuNai() {
  const [value, setValue] = useState();

  useEffect(() => {
    async function fetchData() {
      const { data } = await axiosService.get(`${DOMAIN}/api/v2/page`);
      const htmlPage = data.data.filter(page => page.id === 31);
      setValue(htmlPage[0].content);
    }

    fetchData();
  }, []);

  return (
    <>
      <div className="container full-height">
        <h3>Quy trình hỗ trợ giải quyết tranh chấp, khiếu nại</h3>
        <div className="mt-4">
          <div dangerouslySetInnerHTML={{ __html: value }} />
        </div>
        {/* <div style={{textAlign: 'center'}}>
        <p>Đang cập nhật!</p>
      </div> */}
      </div>
    </>
  );
}

export default TranhChapKhieuNai;
